(() => {
  const images = document.querySelectorAll('[data-home-media]');
  function load(image) {
    const picture = image.closest('picture');
    if (picture) picture.querySelectorAll('[data-home-srcset]').forEach(source => {
      source.setAttribute('srcset', source.dataset.homeSrcset);
      source.removeAttribute('data-home-srcset');
    });
    if (image.dataset.homeSrcset) image.srcset = image.dataset.homeSrcset;
    if (image.dataset.homeSrc) image.src = image.dataset.homeSrc;
    image.removeAttribute('data-home-srcset');
    image.removeAttribute('data-home-src');
    image.removeAttribute('data-home-media');
  }
  if (!('IntersectionObserver' in window)) { images.forEach(load); return; }
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) { observer.unobserve(entry.target); load(entry.target); } });
  }, {rootMargin: '300px'});
  images.forEach(image => observer.observe(image));
})();
